import { Component, input } from "@angular/core";
import { TimesliceDTO } from "src/app/info-management/model/TimesliceDTO";
import { FeatureMetaData } from "../models/FeatureMetadata";

@Component({
  selector: "app-metadata-block",
  standalone: false,
  templateUrl: "./metadata-block.component.html",
  styleUrl: "./metadata-block.component.scss",
})
export class MetadataBlockComponent {
  selectedTimeSlice = input.required<FeatureMetaData>();

  constructor() {}
}
